import styled from 'styled-components';

export const LoginWrapper = styled.div`
	width: 100%;
	text-align: center;
	padding-top: 10%;
	font-size: 1.3em;
	
	& svg {
		margin-bottom: 10px;
		font-size: 2em;
	}
`;